import React from 'react';
import Male from '../../assets/persons/MAN.svg';
import Female from '../../assets/persons/WOMAN.svg';
import { CircularImage } from "../circularImage/CircularImage.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function PersonImage({
  sex,
  ...props
}) {
  const imageUrl = {
    MALE: Male,
    FEMALE: Female,
    OTHER: Male
  }[sex];
  return /*#__PURE__*/_jsx(CircularImage, {
    ...props,
    alt: sex,
    src: imageUrl,
    centered: true
  });
}